import { Text } from "../../Type";

const StringListCell = ({ data }: { data: string[] }) => {
  if (!data.length) return <Text>-</Text>;
  return <Text>{data.join(",")}</Text>;
};

export default StringListCell;
